<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content>{{ data.message }}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close color="primary">Annulla</button>
  <button mat-button [mat-dialog-close]="true" color="warn">Conferma</button>
</mat-dialog-actions>
